import { fieldHistory, fieldJournal } from './field-history';
import { create } from './create';
import { getAllAdminsActivityByDate } from './get-all-admins-activity-by-date';
import { getAllAdminsActivityRequests } from './get-all-admins-activity-requests';
import { getAllAdminsActivityStats } from './get-all-admins-activity-stats';
import { login } from './login';
import { logout } from './logout';
import { me } from './me';
import { query } from './query';
import { remove } from './remove';
import { staffNotes } from './staff-notes';
import { update } from './update';

type ApiDeclaration = {
    create: typeof create;
    query: typeof query;
    remove: typeof remove;
    update: typeof update;
    login: typeof login;
    logout: typeof logout;
    me: typeof me;
    getAllAdminsActivityStats: typeof getAllAdminsActivityStats;
    getAllAdminsActivityByDate: typeof getAllAdminsActivityByDate;
    getAllAdminsActivityRequests: typeof getAllAdminsActivityRequests;
    staffNotes: typeof staffNotes;
    fieldHistory: typeof fieldHistory;
    fieldJournal: typeof fieldJournal;
};

export const adminsApiDeclaration: ApiDeclaration = {
    login,
    update,
    remove,
    query,
    create,
    logout,
    me,
    getAllAdminsActivityStats,
    getAllAdminsActivityByDate,
    getAllAdminsActivityRequests,
    staffNotes,
    fieldHistory,
    fieldJournal,
};
